module.exports = __webpack_public_path__ + "static/media/looknorthlogosmaller.b7060778.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/looknorthlogosmaller.png
// module id = 2008
// module chunks = 0